/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import LessonItem from "../../components/LessonItem/LessonItem";
import Searchbar from "../../components/Searchbar/Searchbar";
// data
import { useFavoriteContext } from "../../context/providers/FavoriteContext";
import { showErrorMessage, showSuccessMessage } from "../../utils/notification";

export default function Favorites(props) {
	const { error, success, getFavorites, favorites, clearNotification, favoriteFilter } = useFavoriteContext();
	React.useEffect(() => {
		getFavorites();
		if (error !== null) {
			showErrorMessage(error);
			clearNotification();
		}
		if (success !== null) {
			showSuccessMessage(success);
			clearNotification();
		}
	}, [success, error]);

	return (
		<div className="container container--main container--limited_width">
			{favorites !== null && favorites.length > 0 ? (
				<>
					<Searchbar searchFavorite={true}></Searchbar>
					<div className="container--default mt-6">
						{favoriteFilter !== null ? (
							<>
								{favoriteFilter.map((item, index) => (
									<LessonItem item={item.lesson} key={index} favoriteKey={item._id}></LessonItem>
								))}
							</>
						) : (
							<>
								{favorites.map((item, index) => (
									<LessonItem item={item.lesson} key={index} favoriteKey={item._id}></LessonItem>
								))}
							</>
						)}
					</div>
				</>
			) : (
				<div className="px-3 py-2" style={{ display: "flex", justifyContent: "center", fontSize: "35px" }}>
					No lessons
				</div>
			)}
		</div>
	);
}
